export const SPECIFIC_GENES_REGEX = /^(\w[-]?)+([\n,\w+]-?)*$/;
